// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string(),
  firstEntry: __t.string().name("first_entry"),
  relatedEntry: __t.string().name("related_entry"),
  relatedEntryType: __t.string().name("related_entry_type"),
  linkType: __t.option(__t.string()).name("link_type"),
  raw: __t.string(),
});
